import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CircularProgress from 'material-ui/CircularProgress';

import { getLoadingAndDischarging } from 'actions/cargoes/ldRates';
import { getTermEntities } from 'actions/termEntities';
import styles from 'styles';

import LDRatesTable from './Table';

class LDRatesPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getLoadingAndDischarging();
        this.props.getTermEntities();
    }

    render() {
        return (
            <div id='cargo-ldrates' className='table-page'>
                <CircularProgress
                    className={!this.props.isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Loading and discharging
                        </h2>
                        <LDRatesTable />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLogged: state.user.isLogged,
            isLoaded: state.ldRates.isLoaded,
        };
    },
    dispatch => bindActionCreators({
        getLoadingAndDischarging,
        getTermEntities,
    }, dispatch),
)(LDRatesPage);


// WEBPACK FOOTER //
// ./app/components/Cargoes/LDRates/Page.jsx